import { ComponentPropsWithRef } from "react";

export const CloseIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    height="17"
    width="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={props.ref}
    {...props}
  >
    <rect
      y="14.1421"
      width="20"
      height="3"
      rx="1"
      transform="rotate(-45 0 14.1421)"
      fill="currentColor"
    />
    <rect
      x="14.1426"
      y="16.2635"
      width="20"
      height="3"
      rx="1"
      transform="rotate(-135 14.1426 16.2635)"
      fill="currentColor"
    />
  </svg>
);
